import {useDispatch} from 'react-redux';
import {AppDispatch} from '../../redux/store/storeTypes';

const useAppDispatch = () => useDispatch<AppDispatch>();

export {useAppDispatch};
